jQuery(document).ready(function ($) {
    $('.request-quote').submit(function (e) {
        e.preventDefault();
        let $form = jQuery(this);
        $form.find('button[type="submit"]').html(request_quote_vars.sending_msg).prop("disabled", true);
        jQuery.ajax({
            type: "post",
            url: request_quote_vars.url,
            data: "action=" + request_quote_vars.action + "&nonce=" + request_quote_vars.nonce + "&" + $(this).serialize(),
            success: function (response) {
                if (response.result) {
                    $form.closest('div').html('<h5>' + request_quote_vars.success_msg + '</h5>');
                    $form.remove();
                } else {
                    $form.closest('div').html('<h5>' + request_quote_vars.error_msg + '</h5>');
                    $form.remove();
                }
            }
        });
    });
});